import { render, staticRenderFns } from "./AreaTable.vue?vue&type=template&id=3632dcdc&"
import script from "./AreaTable.vue?vue&type=script&lang=js&"
export * from "./AreaTable.vue?vue&type=script&lang=js&"
import style0 from "./AreaTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports